import React from 'react';
import { LoaderCircle } from 'lucide-react';

/** Centered spinner for blocks that are still loading. */
export default function Loading() {
    return (
        <div className="w-full h-40 flex items-center justify-center px-8" role="status" aria-label="loading">
            <LoaderCircle className="animate-spin text-[28px] text-primary-600" />
        </div>
    );
}
